import { BaseCustomInteraction, CustomInteractionType, } from './base';
import draw from '@vendor/libs/maps/styles/common/draw';
export class EditAssociationBoundaries extends BaseCustomInteraction {
    constructor(options = {}) {
        super('edit-association-boundaries', CustomInteractionType.EDIT, {
            ...options,
            geometry: 'Polygon',
            style: draw,
        });
    }
}
